export default "__VITE_ASSET__kVqF2VqX__"